(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nt-premium-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const closeHeaderPanels = (except) => {
    document.querySelectorAll('.nt-header details[open]').forEach((panel) => {
      if (panel !== except) panel.removeAttribute('open');
    });
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.nt-header')) closeHeaderPanels();
    const summary = event.target.closest('.nt-header summary');
    if (summary) closeHeaderPanels(summary.parentElement);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = document.querySelector('.nt-header details[open]');
    if (panel) {
      const summary = panel.querySelector('summary');
      closeHeaderPanels();
      if (summary) summary.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
